import { computed, Ref } from 'vue';
import { useStore } from 'vuex';
import { useUserManagement } from './user-management';
import i18n from '@/plugins/i18n';
import { JobRoles, UserResponseDto } from '@clearbanc/baus-sdk';

export function useUserActionsTooltips(userIdRef: Ref<string | undefined>) {
  const store = useStore();
  const { canEditUser, isAuthenticatedUser, isAuthorizedOwnerUser } =
    useUserManagement(userIdRef);

  const businessHasPendingBillContractOrActiveAdvance = computed(
    () => store.getters.businessHasPendingBillContractOrActiveAdvance,
  );

  const user = computed<UserResponseDto | undefined>(() => {
    if (!userIdRef.value) return undefined;
    const users = store.getters.allUsers || [];
    return users.find((user: UserResponseDto) => user.id === userIdRef.value);
  });

  const deletionBlockerTooltipText = computed<string | undefined>(() => {
    if (isAuthenticatedUser.value)
      return i18n.t('data.errorMessages.cannotDeleteYourself');
    if (user.value?.isPrimary)
      return i18n.t('data.errorMessages.cannotDeletePrimaryUser');
    if (user.value?.jobRoles?.includes(JobRoles.Signatory))
      return i18n.t('data.errorMessages.cannotDeleteSignatory');
    if (
      isAuthorizedOwnerUser.value &&
      businessHasPendingBillContractOrActiveAdvance.value
    )
      return i18n.t('data.errorMessages.cannotDeleteAuthorizedOwner');
    return undefined;
  });

  const trashIconTooltipText = computed<string | undefined>(() => {
    return !canEditUser.value
      ? i18n.t('data.errorMessages.cannotUpdateUserDetails')
      : undefined;
  });

  const editButtonTooltipText = computed<string | undefined>(() => {
    if (!canEditUser.value) {
      return i18n.t('data.errorMessages.cannotUpdateUserDetails');
    }
    return undefined;
  });

  return {
    trashIconTooltipText,
    deletionBlockerTooltipText,
    editButtonTooltipText,
  };
}
